import { render, staticRenderFns } from "./billingCorporateDetail.vue?vue&type=template&id=0518974c&scoped=true"
import script from "./billingCorporateDetail.vue?vue&type=script&lang=js"
export * from "./billingCorporateDetail.vue?vue&type=script&lang=js"
import style0 from "./billingCorporateDetail.vue?vue&type=style&index=0&id=0518974c&prod&lang=css"
import style1 from "./billingCorporateDetail.vue?vue&type=style&index=1&id=0518974c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0518974c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VDataTable,VRow,VSpacer})
